module.exports = __webpack_public_path__ + "static/media/ceilings_material_60yd_n.f6917b4d.csv";